import { render, staticRenderFns } from "./bo-panel.vue?vue&type=template&id=5a53c60e"
import script from "./bo-panel.vue?vue&type=script&lang=js"
export * from "./bo-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports